module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0104.jpg?v=7a25cf76";